import { Box, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import Navbar from 'components/navbar';
import v2Theme from 'theme/v2Theme';
import V2Footer from './V2Footer';
import 'styles/v2.css';

const V2PageShell = ({ children }) => (
  <ThemeProvider theme={v2Theme}>
    <Box className="v2-shell" sx={{ display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>{children}</Box>
      <V2Footer />
    </Box>
  </ThemeProvider>
);

V2PageShell.propTypes = {
  children: PropTypes.node.isRequired,
};

export default V2PageShell;
